export default __webpack_public_path__ + "static/media/wind-mirror-unaccept.ca5c23fe.png";